
import { Component, Prop, Vue } from "vue-property-decorator";
import Table from "@/domain/restaurant/Table";
import TableCard from "@/components/restaurant/table/TableCard.vue";
import Room from "@/domain/restaurant/Room";
import UtilService from "@/services/UtilService";
import TableDialog from "@/components/restaurant/table/TableDialog.vue";
@Component({
  components: { TableDialog, TableCard }
})
export default class TableList extends Vue {
  @Prop({
    default: () => {
      return new Room();
    }
  })
  room!: Room;

  selectedTable: Table = new Table();

  tableDialog = false;

  newTableDialog = false;

  get hasRoom() {
    return !!this.room.roomId;
  }

  showTableDialog(table: Table) {
    this.selectedTable = table;
    this.tableDialog = true;
  }

  showNewTableDialog() {
    this.selectedTable = new Table();
    this.newTableDialog = true;
  }

  mounted() {
    this.room.tables.sort(Table.TablesByNameAscendingComparator);
  }

  addTable(newTable: Table) {
    this.room.tables.push(newTable);
  }

  removeTable(toRemove: Table) {
    UtilService.removeFromArray(this.room.tables, toRemove);
  }

  get isAdmin() {
    return this.$store.getters.isAdmin;
  }
}
